import { Pipe, PipeTransform } from "@angular/core";
import LoggerService from "@bfx/logger/dist";
import { moment, TimeZoneImpl } from "shared/cubiq-model-multi-asset";
import { BmarkFixingData } from "shared/cubiq-services";

const logger = LoggerService.for(__dirname);

/**
 * Pipe that formats the fixing time based on the input timezone.
 * Implemented as pipe so should only recalucate when TZ or fixing changes
 */
@Pipe({
  name: "fixingTime",
  standalone: false,
})
export class BfxFixingTimePipe implements PipeTransform {
  /**
   * Get the formatted time from the Fixing data. If no tz setting is defined, then the default
   * label is used, otherwise it will format the time according to the configured timezone
   * @param fixingData
   * @param displayTZ
   * @returns
   */
  transform(fixingData: BmarkFixingData, displayTZ: TimeZoneImpl): string {
    // logger.out.info("Getting fixing time");
    if (!displayTZ) {
      return fixingData.displayTime;
    }
    const fixingTime = fixingData.fixingId.time;
    const tzMoment = moment.tz(fixingTime.valueOf(), displayTZ.javaTimeZoneCd);
    return `${tzMoment.format("HH:mm")} ${displayTZ.id}`;
  }
}
